import * as angular from "angular";
import {IController, ILogService} from "angular";
import {PricePlanBundleService} from "../../services/price-plan-bundle.service";
import {ItemSetting} from "../../models/itemSetting.model";
import * as _ from "lodash"
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {TranslateService} from "@ngx-translate/core";
import {SortType} from "../../../commons/types/sort.type";
import {SplitService} from "../../../commons/services/split-service.service";

export class PricePlanBundlePackageItemsViewCtrl implements IController {

  public queryString: string;
  public allPackageItems: ItemSetting[];
  public packageItemOptions: ItemSetting[];
  public packageItems: ItemSetting[];
  public defaultPackageItemId: string;
  public editedPackageItemId: ItemSetting;
  public selectedSortType?: SortType;
  public selectedSortName?: string;

  /* @ngInject */
  constructor(private pricePlanBundleService: PricePlanBundleService, private $log: ILogService,
              private $translate, private splitService: SplitService,
              private pricePlanConstant, private confirmDialogService: ConfirmDialogService) {
    this.allPackageItems = this.pricePlanConstant.packageItemsDefaultSettings
  }

  $onInit() {
    this._getPackageItems();
  }

  onSubmitQuery(query) {
    this.queryString = query;
  }

  onSortChange(sortName, sortType) {
    const isSameSortName = !!sortType && _.isEqual(this.selectedSortType, sortType);
    this.selectedSortType = isSameSortName ? (_.isEqual(this.selectedSortType, SortType.asc) ? SortType.desc : SortType.asc) : SortType.asc;
    this.selectedSortName = sortName;

    if (this.selectedSortType && this.selectedSortName) {
      this._sortItems();
    }
  }

  onEditPackageItem(packageItem: ItemSetting) {
    this.editedPackageItemId = packageItem.id;
  }

  onCancelEditPackageItem() {
    this.editedPackageItemId = undefined;
  }

  onSavePackageItem(editedPackageItem: ItemSetting) {
    this.pricePlanBundleService.updatePackageItem(editedPackageItem.id, editedPackageItem)
      .then((updatedPackageItem: ItemSetting) => {
        this.editedPackageItemId = undefined;

        const editedItemIndex: number = _.findIndex(this.packageItems, (item) => {
          return item.id === updatedPackageItem.id;
        })

        if (editedItemIndex > -1) {
          const packageItemsCopy = angular.copy(this.packageItems);
          packageItemsCopy[editedItemIndex] = updatedPackageItem;

          this.packageItems = packageItemsCopy;
          this._setPackageItemOptions();
        }
        // this.packageItems = _.uniqBy(_.concat([updatedPackageItem], this.packageItems), 'id');
      })
  }

  onCreatePackageItem(packageItem: ItemSetting) {
    this.pricePlanBundleService.createPackageItem(packageItem)
      .then((createdPackageItem: ItemSetting) => {
        this.packageItems = _.uniqBy(_.concat([createdPackageItem], this.packageItems), 'id');
        this._setPackageItemOptions();
      })
  }

  onSetDefaultPackageItem(packageItem: ItemSetting) {
    const currentDefaultPackageItemId = angular.copy(this.defaultPackageItemId);
    const text = this.$translate.instant('X_SET_DEFAULT_PACKAGE', {name: packageItem.name});
    return this.confirmDialogService.confirm('Set Default Package', text)
      .then(() => {
        return this.pricePlanBundleService.setDefaultPackageItem(packageItem.id)
      })
      .then((updatedPackageItemsList: ItemSetting[]) => {
        this.packageItems = updatedPackageItemsList;
        this._setPackageItemOptions();
        this._setDefaultPackageItemId();
      })
      .catch((error) => {
        this.defaultPackageItemId = currentDefaultPackageItemId;
        this.$log.info('Dialog Closed', error);
      })


    // this.pricePlanBundleService.setDefaultPackageItem(packageItem.id)
    //   .then((updatedPackageItemsList: ItemSetting[]) => {
    //     this.packageItems = updatedPackageItemsList;
    //     this._setPackageItemOptions();
    //     this._setDefaultPackageItemId();
    //   })
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getPackageItems() {
    this.pricePlanBundleService.getPackageItems()
      .then((packageItems: ItemSetting[]) => {
        this.packageItems = packageItems;
        this._setPackageItemOptions();
        this._setDefaultPackageItemId();
        this._setPackageConfigName();
      })
  }

  private _setPackageItemOptions() {
    const excludeIds = _.map(this.packageItems, 'name'); // TODO check if can be changed to id (debug)
    this.packageItemOptions = _.filter(this.allPackageItems, (item) => {
      return !_.includes(excludeIds, item.name);
    })
  }

  private _setDefaultPackageItemId() {
    const defaultPackage = _.find(this.packageItems, (item) => {
      return !!item.defaultSize;
    })
    this.defaultPackageItemId = defaultPackage ? defaultPackage.id : undefined;
  }

  private _sortItems() {
    this.packageItems = _.orderBy(this.packageItems, [this.selectedSortName], [this.selectedSortType]);
  }

  private _setPackageConfigName() {
    this.packageItems.forEach((item: any) => {
      if (item.packageConfigurationId) {
        item.packageConfigName = this.splitService.getSitePackageConfigurations().find((pc) => pc.id === item.packageConfigurationId)?.name;
      }
    })
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanBundlePackageItemsView', {
    bindings: {},
    template: require('./price-plan-bundle-package-items-view.html').default,
    controller: PricePlanBundlePackageItemsViewCtrl
  });
